import 'rxjs/add/observable/of';
import { Observable } from 'rxjs/Observable';
import URL from 'url-parse';
import { getNextgenSettingsJSDAutomationUrl } from '@atlassian/jira-project-settings-apps-common/src/urls';
import type { Action } from '@atlassian/jira-servicedesk-common/src/model/types';
import { navigate, navigateAction } from './actions';

export const toSummary = (projectKey: string, ignoreOrigin = false): Observable<Action> => {
	const url = new URL(window.location.href, true);
	const { origin } = url.query;
	// 'origin' query param may contain a URL relative to the project settings
	// base URL, which is the URL to navigate to.
	if (!ignoreOrigin && origin) {
		return navigate(projectKey, decodeURIComponent(origin));
	}
	return navigate(projectKey, 'automation');
};

// For simplified projects, we are not using push state navigator
// So we bypass the push state navigator check and just return the action directly
export const toSimplifiedSummary = (baseUrl: string, projectKey: string) =>
	Observable.of(navigateAction(getNextgenSettingsJSDAutomationUrl(projectKey)));

export const toCreateRule = (projectKey: string, blueprintModuleKey: string): Observable<Action> =>
	navigate(projectKey, `automation/blueprint/${encodeURIComponent(blueprintModuleKey)}`);

export const toSimplifiedCreateRule = (
	baseUrl: string,
	projectKey: string,
	blueprintModuleKey: string,
) =>
	Observable.of(
		navigateAction(
			`${getNextgenSettingsJSDAutomationUrl(projectKey)}/blueprint/${blueprintModuleKey}`,
		),
	);

export const toEditRule = (projectKey: string, ruleSetId: string): Observable<Action> =>
	navigate(projectKey, `automation/ruleset/${ruleSetId}`);

export const toSimplifiedEditRule = (baseUrl: string, projectKey: string, ruleSetId: string) =>
	Observable.of(
		navigateAction(`${getNextgenSettingsJSDAutomationUrl(projectKey)}/ruleset/${ruleSetId}`),
	);

export const toCopyRule = (projectKey: string, ruleSetId: string): Observable<Action> =>
	navigate(projectKey, `automation/copy/${ruleSetId}`);

export const toSimplifiedCopyRule = (baseUrl: string, projectKey: string, ruleSetId: string) =>
	Observable.of(
		navigateAction(`${getNextgenSettingsJSDAutomationUrl(projectKey)}/copy/${ruleSetId}`),
	);

export const toViewLog = (projectKey: string, ruleSetId: string): Observable<Action> =>
	navigate(projectKey, `automation/log/${ruleSetId}`);

export const toSimplifiedViewLog = (baseUrl: string, projectKey: string, ruleSetId: string) =>
	Observable.of(
		navigateAction(`${getNextgenSettingsJSDAutomationUrl(projectKey)}/log/${ruleSetId}`),
	);

export const getAutomationUrl = (projectKey: string): string =>
	getNextgenSettingsJSDAutomationUrl(projectKey);
